import React, { Component } from 'react';

import { isEqual as _isEqual, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Types } from '@vfgroup-oneplatform/foundation/Components/Themes';

import DetailsScreen from '../DetailsScreen/DetailsScreen';
import { getStatus, getHeaderxStatusText, getItemStatus } from '../Utils';
import { EIOkeys } from '../Utils/Enums';

import EverythingIsOkHeader from './EverythingIsOkHeader';

class EIOHeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: EIOkeys.everything_is_ok_in_progress_text,
      status: 2,
      spaceType: 1,
    };
  }

  componentDidMount() {
    const { data, onChange } = this.props;
    if (data.length < 1 || !data) {
      this.setState({
        status: 2,
        spaceType: 1,
        message: EIOkeys.everything_is_ok_in_progress_text,
      });
      onChange(Types.SECONDARY);
      this.onChangeSpaceType(1);
    } else {
      const status = getStatus(data);
      this.updateStatus(status, onChange);
    }
  }
  componentDidUpdate(prevProps) {
    const { onChange, data } = this.props;
    const status = getStatus(data);

    if (!_isEqual(prevProps.data, data)) {
      this.updateStatus(status, onChange);
    }
  }
  onChangeSpaceType = value => {
    const { onChangeSpaceType } = this.props;
    if (_isFunction(onChangeSpaceType)) {
      onChangeSpaceType(value);
    }
  };

  getIcons = data => {
    const { icons } = this.props;
    return (data || [])
      .map(item => ({
        icon: icons[item.icon],
        status: getItemStatus(item).status,
      }))
      .reverse();
  };
  changeGreetingMessage = message => {
    this.setState({ message });
  };
  handelTitleChange = prevStatus => {
    const { data } = this.props;
    const status = getStatus(data);
    this.setState({ message: getHeaderxStatusText(status), spaceType: 1 });
    const duration = 5000;
    if (prevStatus.status !== 0) {
      setTimeout(() => {
        if (this.state.status === 0) {
          this.setState({
            message: EIOkeys.everything_is_ok_greeting_text,
            spaceType: 0,
          });
          this.onChangeSpaceType(0);
        }
      }, duration);
    }
  };
  updateStatus = (status, onChange) => {
    const statusType = status === 0 ? Types.PRIMARY : Types.SECONDARY;
    if (status !== 0) {
      this.onChangeSpaceType(1);
    }
    this.handelTitleChange(status);
    this.setState({ status }, () => {
      onChange(statusType);
    });
  };
  handelOnPress = () => {
    this.props.onPress(this.changeGreetingMessage);
  };
  render() {
    const { message, status, spaceType } = this.state;
    const {
      data,
      getLogoRef,
      onRefresh,
      username,
      refreshInterval,
      onExpantionChange,
      runAnimation,
      icons,
      getAnimationValue,
      onEIOActionPress,
      subTitle,
      ...extraProps
    } = this.props;
    const type = status === 0 ? Types.PRIMARY : Types.SECONDARY;
    return (
      <EverythingIsOkHeader
        title={message}
        icons={this.getIcons(data)}
        placeHolders={[username]}
        type={type}
        withSpace={spaceType !== 0}
        getLogoRef={getLogoRef}
        onRefresh={onRefresh}
        refreshInterval={refreshInterval}
        onPress={this.handelOnPress}
        runAnimation={runAnimation}
        blinkHeader={status === 2}
        onExpantionChange={onExpantionChange}
        getAnimationValue={getAnimationValue}
        subTitle={subTitle}
        status={status}
        {...extraProps}
      >
        <DetailsScreen
          data={data}
          placeHolders={[username]}
          icons={icons}
          onEIOActionPress={onEIOActionPress}
          type={type}
          status={status}
        />
      </EverythingIsOkHeader>
    );
  }
}
EIOHeaderContainer.propTypes = {
  onPress: PropTypes.func,
  onChangeSpaceType: PropTypes.func,
  data: PropTypes.array,
  onChange: PropTypes.func,
  getLogoRef: PropTypes.func,
  onRefresh: PropTypes.func,
  username: PropTypes.string,
  refreshInterval: PropTypes.number,
  onExpantionChange: PropTypes.func,
  runAnimation: PropTypes.bool,
  icons: PropTypes.object,
  getAnimationValue: PropTypes.func,
  onEIOActionPress: PropTypes.func,
  subTitle: PropTypes.string,
};
export default EIOHeaderContainer;
